import { Badge, Card, CardContent, CardHeader, CardTitle } from '@yeshuman/sdk'
import { CalendarCheck } from 'lucide-react'

import type { AppointmentBooking } from '../hooks/use-call-outcomes'
import { formatAppointmentStartAt } from '../lib/appointment-windows'

function syncBadgeVariant(syncStatus: string) {
  if (syncStatus === 'dirty') return 'warningSoft' as const
  if (syncStatus === 'synced') return 'successSoft' as const
  return 'secondary' as const
}

export function CallBookingSummary({
  booking,
  patientName,
  contactName,
}: {
  booking: AppointmentBooking
  patientName?: string
  contactName?: string
}) {
  const pet = patientName?.trim() || null
  const contact = contactName?.trim() || null

  return (
    <Card>
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2 space-y-0">
        <CardTitle className="flex items-center gap-2">
          <CalendarCheck className="h-4 w-4" aria-hidden />
          Appointment booked
        </CardTitle>
        <div className="flex flex-wrap gap-1.5">
          <Badge variant="successSoft" className="font-normal">
            {booking.booking_status || 'confirmed'}
          </Badge>
          <Badge variant={syncBadgeVariant(booking.sync_status)} className="font-normal">
            {booking.sync_status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <p className="text-foreground">
          <span className="font-medium">
            {booking.appointment_type_name || 'Appointment'}
          </span>
          {pet ? (
            <>
              {' '}
              for <span className="font-medium">{pet}</span>
            </>
          ) : null}
          {booking.resource_name ? (
            <>
              {' '}
              with <span className="font-medium">{booking.resource_name}</span>
            </>
          ) : null}
        </p>
        {contact ? (
          <p className="text-muted-foreground">Contact: {contact}</p>
        ) : null}
        <p className="text-muted-foreground tabular-nums">
          {formatAppointmentStartAt(booking.start_at)} · {booking.duration_minutes} min ·{' '}
          {booking.provider}
        </p>
        {booking.external_appointment_uid ? (
          <p className="font-mono text-xs text-muted-foreground">
            {booking.external_appointment_uid}
          </p>
        ) : null}
      </CardContent>
    </Card>
  )
}
